/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { useState, useMemo } from 'react';
import { Accordion } from '@mui/material';
import { AccordionSummary } from '@mui/material';
import { AccordionDetails } from '@mui/material';
import CollapseIcon from './collapseIcon';
import useStyles from './style';
import { SerializedStyles } from '@emotion/react';

const Collapse: React.FC<
  React.PropsWithChildren & {
    items: {
      heading: string | React.ReactElement;
      details: string | React.ReactElement;
    }[];
    id: string | number;
    icon?: React.ReactNode;
    css?: SerializedStyles;
    className?: string
  }
> = ({ items, id, icon, className, ...props }) => {
  const [expanded, setExpanded] = useState(
    Array(items?.length || 0).fill(false)
  );
  const collapseItems = useMemo(() => items || [], [items]);
  const { collapseWrapper, collapseHeader, collapseDetails } = useStyles();

  const handleChange = (exp: boolean, index: number) => {
    setExpanded(() => {
      const newExpanded = [...expanded];
      newExpanded[index] = exp;
      return newExpanded;
    });
  };

  return (
    <>
      {collapseItems.map((e, i) => {
        return (
          <Accordion
            id={`${id}-collapse-${i}`}
            disableGutters
            elevation={0}
            expanded={expanded[i]}
            css={collapseWrapper}
            onChange={(_, exp) => handleChange(exp, i)}
            key={`collapse-item-${i}`}
            className={className}
            {...props}
          >
            <AccordionSummary
              css={collapseHeader}
              expandIcon={icon || <CollapseIcon expanded={expanded[i]} />}
              aria-controls={`collapse-${i}-content`}
              id={`collapse-${i}-header`}
            >
              {e.heading}
            </AccordionSummary>
            <AccordionDetails css={collapseDetails}>
              {typeof e.details === 'object' ? (
                e.details
              ) : (
                <div dangerouslySetInnerHTML={{ __html: e.details }}></div>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default Collapse;
